import { CurrencyPipe, DecimalPipe, NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '@zero/shared/ui-web-design-system';
import { MyStatsBase } from '@zero/statistics/feature-statistics/base';

@Component({
  selector: 'statistics-my-stats',
  templateUrl: './my-stats.component.html',
  styleUrls: ['./my-stats.component.scss'],
  imports: [TranslocoPipe, ModalComponent, DecimalPipe, NgClass, CurrencyPipe],
})
export class MyStatsComponent extends MyStatsBase {
  public readonly modal = inject(NgbModal);
}
